// src/component/common/PriceDisplay.jsx
import { useCurrencyStore } from '../../stores/currency.store.ts';
import { formatPriceParts } from '../../utils/currency.ts';

// `currency` 를 주면 그 통화로 표기한다. 안 주면 지금까지처럼 표시 통화를 쓴다 —
// 쿠폰처럼 «자기 통화» 를 갖고 오는 금액은 스토어 통화로 라벨을 붙이면 거짓말이 된다.
export function PriceDisplay({ price, className = '', prefix = '', currency: currencyProp }) {
  const storeCurrency = useCurrencyStore((s) => s.currency);
  const currency = currencyProp ?? storeCurrency;
  const { main, decimal } = formatPriceParts(price ?? 0, currency);

  return (
    <span className={className}>
      {prefix}
      {main}
      {decimal && (
        <span className="text-[0.72em] text-text-tertiary align-baseline">{decimal}</span>
      )}
    </span>
  );
}
